import React, { useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import { useLocation } from 'react-router-dom'
import { grey } from '@mui/material/colors'

import TextAnalysisHeader from './Header'
import TextAnalysisTabs from './Tabs'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { getTAConfigDetails } from './Helpers/InitialDataLoader'
import { TextAnalysisSkeleton } from './Helpers/TextAnalysisSkeleton'

const TextAnalysis = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const isAdminTAPage = useMemo(
    () => location.pathname.startsWith('/adm/text_analysis'),
    [location.pathname],
  )
  const { fetching: siteFetching, doneFetching: siteDoneFetching } =
    useAppSelector((state) => state.site)
  const { doneAnalysis } = useAppSelector(
    (state) => state.textAnalysis.main.appConfig,
  )

  const isSiteReady = !siteFetching && siteDoneFetching
  useEffect(() => {
    if (isSiteReady) getTAConfigDetails(dispatch)
  }, [dispatch, isSiteReady])

  return (
    <Box
      flexGrow={1}
      data-testid="ta-dashboard"
      sx={{
        minHeight: !isAdminTAPage ? '100vh' : 'calc(100vh - 4rem)',
        padding: !isAdminTAPage ? { xs: '0 1rem', sm: '0 2.5rem' } : 0,
        backgroundColor: !isAdminTAPage ? grey[100] : 'transparent',
      }}
    >
      <Grid container height="100%" flexDirection="column">
        {doneAnalysis ? (
          <>
            <TextAnalysisHeader />
            <TextAnalysisTabs />
          </>
        ) : (
          <TextAnalysisSkeleton />
        )}
      </Grid>
    </Box>
  )
}

export default React.memo(TextAnalysis)
